__turbopack_context__.v({
  "loader": "ModalLoader-module__MNy8xG__loader",
});
